import GameRepository from './game.repository'
import MultiprojectRepository from './multiproject.repository'
import MultiprojectDrawRepository from './multiproject-draw.repository'
import MultitaskRepository from './multitask.repository'
import NetworkDiagramRepository from './networkdiagram.repository'
import OnTimeRepository from './ontime.repository'
import CriticalChainRepository from './criticalchain.repository'

export default {
  game: GameRepository,
  multiproject: MultiprojectRepository,
  multiprojectDraw: MultiprojectDrawRepository,
  multitask: MultitaskRepository,
  networkdiagram: NetworkDiagramRepository,
  ontime: OnTimeRepository,
  criticalchain: CriticalChainRepository,
}
